/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneBestOfAfrica } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MyButton,
  MySearch,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import PromoteContent from "../utils/PromoteContent";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/bestofafrica/add";
const editRoute = "/data/bestofafrica/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [bestOfAfricaList, setBestOfAfricaList] = useState([]);
  const { bestOfAfrica, bestOfAfricaCount, fetchDoSeeData, deleteOneContent } =
    useDoSeeDataContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  const [loading, setLoading] = useState(false);

  const [selectedContentIds, setSelectedContentIds] = useState([]);

  const [localSearch, setLocalSearch] = useState([]);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.BESTOFAFRICA,
  };

  useEffect(() => {
    if (!bestOfAfrica) fetchDoSeeData(data_request_body, page, pageSize);
    else setBestOfAfricaList(bestOfAfrica);
  }, [bestOfAfrica]);

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    bestOfAfrica.map((b_o_a) => {
      if (b_o_a?.title.toString().toLowerCase().includes(key))
        return searchArray.push(b_o_a);
      return true;
    });

    setBestOfAfricaList(searchArray);
    if (key === "") setBestOfAfricaList(bestOfAfrica);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : bestOfAfricaList;

  const deleteMany = async () => {
    setLoading(true);

    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.BESTOFAFRICA,
      });
    }

    setLoading(false);

    reloadData();
  };

  return (
    <div className="p-3 lg:p-4  h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <BreadCrumbComponent />
      <GoBack props={{ route: doseeDataRoutes }} />
      <div className="my-3">
        <DashboardIntro props={{ intro: `Best`, name: entry_label }} />
      </div>
      <div className="flex flex-col justify-center">
        <MySearch
          type={_TYPES_.BESTOFAFRICA}
          value={localSearch}
          showGlobalSearch={true}
          setValue={setLocalSearch}
          onChange={(e) => SearchList(e)}
        />

        <div className="w-full flex justify-end my-5">
          {country_id ? (
            <Link to={addRoute}>
              <MyButton
                title="Add Best Of Africa"
                className="py-3 px-8 bg-blue-900 hover:bg-blue-600"
                onClick={() => {}}
              />
            </Link>
          ) : null}
        </div>

        <div className="flex items-center">
          <MyButton className="text-black flex items-center space-x-2">
            {selectedContentIds?.length === LocalData?.length ? (
              <FaRegCheckSquare
                onClick={() => setSelectedContentIds([])}
                className="text-green-500 cursor-pointer text-lg"
              />
            ) : (
              <FaRegSquare
                onClick={() => {
                  const ids = LocalData.map(
                    (attraction) => attraction?.attraction_id
                  );
                  setSelectedContentIds(ids);
                }}
                className="cursor-pointer text-black text-lg"
              />
            )}
            <p className="text-black">
              {selectedContentIds.length === LocalData?.length
                ? "Unselect All"
                : "Select All"}
            </p>
          </MyButton>

          <MyButton
            onClick={deleteMany}
            className="text-black flex items-center space-x-2"
          >
            {loading ? (
              <RiRefreshLine className="text-black text-lg animate-spin" />
            ) : (
              <FaRegTrashAlt className="text-red-500 cursor-pointer text-base" />
            )}
            <p className="text-black">
              Delete {selectedContentIds?.length} Item(s)
            </p>
          </MyButton>
        </div>

        <div className="mb-5 overflow-y-auto w-full py-2">
          <table className="table-auto w-full border-collapse border border-gray-300 text-xs text-left">
            <thead>
              <tr className="space-x-2">
                <th className="border p-2 lg:px-4 font-bold w-1/3">Select</th>
                <th className="border p-2 lg:px-4 font-bold w-1/3">Title</th>
                <th className="border p-2 lg:px-4 font-bold w-1/3">Slug</th>
                <th className="border text-center w-1/3">Action</th>
              </tr>
            </thead>
            <tbody className="space-x-2 text-left border-gray-300">
              {bestOfAfrica || LocalData ? (
                LocalData?.map((b_o_a, key) => (
                  <tr key={key}>
                    <td className="border px-2 lg:px-4 w-1/3 text-lg">
                      {selectedContentIds.includes(b_o_a?.best_of_africa_id) ? (
                        <MyButton
                          onClick={() => {
                            const filteredIds = selectedContentIds.filter(
                              (id) => id !== b_o_a?.best_of_africa_id
                            );
                            setSelectedContentIds(filteredIds);
                          }}
                        >
                          <FaRegCheckSquare className="text-green-500 cursor-pointer text-lg" />
                        </MyButton>
                      ) : (
                        <MyButton
                          onClick={() =>
                            setSelectedContentIds([
                              ...selectedContentIds,
                              b_o_a?.best_of_africa_id,
                            ])
                          }
                        >
                          <FaRegSquare className="cursor-pointer text-black text-lg" />
                        </MyButton>
                      )}
                    </td>
                    <td className="border px-2 lg:px-4 w-1/3">
                      {b_o_a?.title}
                    </td>
                    <td className="border px-2 lg:px-4 w-1/3">{b_o_a?.slug}</td>
                    <td className="border w-1/3">
                      <ActionButton props={b_o_a} reloadData={reloadData} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total_items={bestOfAfricaCount}
          callbackFunction={(p, size) => {
            fetchDoSeeData(data_request_body, p, size);
          }}
        />
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props, reloadData }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { bestOfAfrica, deleteOneContent, updateOneContent } =
    useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);

  const [promote, setPromote] = useState(false);
  const [promoteLoader, setPromoteLoader] = useState(false);

  const best_of_africa_id = props?.best_of_africa_id;
  const bestOfAfrica_title = props?.title;
  const _bestOfAfrica_ = props;

  const deleteOneBestOfAfricaById = async (best_of_africa_id) => {
    const { status } = await deleteOneContent({
      data_id: best_of_africa_id,
      content: _TYPES_.BESTOFAFRICA,
    });

    setShowModal(false);

    if (status === 200) {
      reloadData();
    }
  };

  const buildData = (object, position) => {
    return {
      country_id: object?.country_id,
      description: object?.description,
      first_level_id: object?.first_level_id,
      fourth_level_id: object?.fourth_level_id,
      promoted: `${position}`,
      second_level_id: object?.second_level_id,
      slug: object?.slug,
      status: object?.status,
      third_level_id: object?.third_level_id,
      thumbnail: object?.thumbnail,
      title: object?.title,
      url_images: object?.url_images,
    };
  };

  /**
   *
   * @author Ntavigwa Bashombe
   * @param {*} restaurant
   */
  const promotion = async (position) => {
    const previousPromoted = bestOfAfrica?.find(
      (best_of_africa) => best_of_africa?.promoted === String(position)
    );

    setPromoteLoader(true);

    const { status } = await updateOneContent({
      data_id: _bestOfAfrica_?.best_of_africa_id,
      data: buildData(props, position),
      content: _TYPES_.BESTOFAFRICA,
    });

    if (previousPromoted) {
      await updateOneContent({
        data_id: previousPromoted?.best_of_africa_id,
        data: buildData(previousPromoted, "no"),
        content: _TYPES_.BESTOFAFRICA,
      });
    }

    if (status === 200) {
      reloadData();
    }
  };

  /**
   *
   * @author Ntavigwa Bashombe
   * @param {*} restaurant
   */
  const suspension = async (b_o_a) => {
    const data = {
      country_id: b_o_a?.country_id,
      description: b_o_a?.description,
      first_level_id: b_o_a?.first_level_id,
      fourth_level_id: b_o_a?.fourth_level_id,
      promoted: b_o_a?.promoted,
      second_level_id: b_o_a?.second_level_id,
      slug: b_o_a?.slug,
      status: b_o_a?.status === 1 ? 0 : 1,
      third_level_id: b_o_a?.third_level_id,
      thumbnail: b_o_a?.thumbnail,
      title: b_o_a?.title,
      url_images: b_o_a?.url_images,
    };

    const { status } = await updateOneContent({
      data_id: b_o_a?.best_of_africa_id,
      data: data,
      content: _TYPES_.BESTOFAFRICA,
    });

    if (status === 200) {
      reloadData();
    }
  };

  return (
    <>
      <Modal
        props={{
          name: bestOfAfrica_title,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneBestOfAfricaById(best_of_africa_id),
        }}
      />

      <PromoteContent
        visible={promote}
        setVisible={setPromote}
        loading={promoteLoader}
        ids={bestOfAfrica
          ?.filter(
            (best_of_africa) =>
              !["yes", "no", null, undefined].includes(best_of_africa?.promoted)
          )
          .map((best_of_africa) => ({
            id: best_of_africa?.best_of_africa_id,
            title: best_of_africa?.title,
            position: parseInt(best_of_africa?.promoted),
          }))}
        onClick={(position) => promotion(position)}
      />

      <div className="flex flex-row justify-end items-center px-2 py-3 space-x-4 text-xs">
        {isSuperAdmin ? (
          <>
            <MyButton
              title={bestOfAfrica?.status === 1 ? "Suspend" : "Unsuspend"}
              className={`py-3 px-8 ${
                bestOfAfrica?.status === 1
                  ? "bg-gray-900 hover:bg-gray-600"
                  : "bg-orange-900 hover:bg-orange-600"
              }`}
              onClick={() => suspension(bestOfAfrica)}
            />
            <MyButton
              title={
                ["yes", "no", null, undefined].includes(bestOfAfrica?.promoted)
                  ? "Promote"
                  : "Unpromote"
              }
              className={`py-3 px-8 ${
                ["yes", "no", null, undefined].includes(bestOfAfrica?.promoted)
                  ? "bg-gray-900 hover:bg-gray-600"
                  : "bg-orange-900 hover:bg-orange-600"
              }`}
              onClick={() => setPromote(true)}
            />
          </>
        ) : null}

        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`py-3 px-8 bg-blue-800 hover:bg-blue-600`}
            onClick={() => pushOneBestOfAfrica(_bestOfAfrica_)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`py-3 px-8 bg-red-800 hover:bg-red-600`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
